import {useLocation} from "react-router-dom";
import {ACTIONS_ROUTE, HOME_ROUTE, OKR_ROUTE, STRATEGY_ABSOLUTE_ROUTE} from "../../routes/routesName";
import styled from "styled-components";

const Help = () => {
    const {pathname} = useLocation()

    const getPathName = () => {
        if (pathname === HOME_ROUTE) {
            return "projets"
        }
        if (pathname === STRATEGY_ABSOLUTE_ROUTE) {
            return "strategie"
        }
        if (pathname === ACTIONS_ROUTE) {
            return "actions"
        }
        if (pathname === OKR_ROUTE) {
            return "indicateurs"
        }
    }

    return (
        <NavIcon href={process.env.REACT_APP_ENJOYYOURBUSINESS_URL + getPathName()} target="_blank" rel="noreferrer">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#4909AA"/>
                <path
                    d="M12.0165 14.5C11.7609 14.5 11.5581 14.4111 11.4081 14.2333C11.2581 14.0556 11.1998 13.8389 11.2331 13.5833C11.2887 13.1833 11.4081 12.8278 11.5915 12.5167C11.7748 12.2056 12.0554 11.8833 12.4331 11.55C12.8998 11.1278 13.2581 10.7361 13.5081 10.375C13.7581 10.0139 13.8831 9.62778 13.8831 9.21667C13.8831 8.71667 13.7165 8.3 13.3831 7.96667C13.0498 7.63333 12.5831 7.46667 11.9831 7.46667C11.572 7.46667 11.2304 7.55 10.9581 7.71667C10.6859 7.88333 10.4665 8.08889 10.2998 8.33333C10.1776 8.51111 10.022 8.63333 9.83313 8.7C9.64425 8.76667 9.46091 8.76111 9.28313 8.68333C9.06091 8.59444 8.9248 8.43333 8.8748 8.2C8.8248 7.96667 8.86091 7.75556 8.98313 7.56667C9.29425 7.11111 9.70258 6.73611 10.2081 6.44167C10.7137 6.14722 11.3054 6 11.9831 6C13.0942 6 13.9498 6.30833 14.5498 6.925C15.1498 7.54167 15.4498 8.28333 15.4498 9.15C15.4498 9.68333 15.3359 10.1667 15.1081 10.6C14.8804 11.0333 14.5165 11.4889 14.0165 11.9667C13.6276 12.3444 13.3554 12.65 13.1998 12.8833C13.0442 13.1167 12.9442 13.3833 12.8998 13.6833C12.8665 13.9167 12.7665 14.1111 12.5998 14.2667C12.4331 14.4222 12.2387 14.5 12.0165 14.5ZM11.9831 18.6667C11.6609 18.6667 11.3859 18.5528 11.1581 18.325C10.9304 18.0972 10.8165 17.8222 10.8165 17.5C10.8165 17.1778 10.9304 16.9028 11.1581 16.675C11.3859 16.4472 11.6609 16.3333 11.9831 16.3333C12.3054 16.3333 12.5804 16.4472 12.8081 16.675C13.0359 16.9028 13.1498 17.1778 13.1498 17.5C13.1498 17.8222 13.0359 18.0972 12.8081 18.325C12.5804 18.5528 12.3054 18.6667 11.9831 18.6667Z"
                    fill="#FAFAFA"/>
            </svg>
            <p>Aide</p>
        </NavIcon>
    )
}

const NavIcon = styled.a`
  display: flex;
  flex-direction: column;
  &:hover {
    circle {
      fill: var(--color-purple-lighten);
    }

    path {
      fill: var(--color-purple)
    }
  }
`
export default Help